import GameObject, { GameObjectEvent } from '../GameObject/GameObject';
import Component from './Component';
import * as PIXI from 'pixi.js';
import ColorFilter from './ColorFilter';
import { MathHelper } from '../Utility/MathHelper';
import Game from '../Game';
import { TaskEvents } from '../Utility/Task/TaskQueue';

export default class Interactable extends Component<PIXI.Container, GameObject> {
    /**
     * Store the current pointer target. If this same target triggers a "pointer-up" event then emit
     * the "selected" event.
     */
    public static pointerTargetGameObject: GameObject;
    private _toggleable: boolean = false;
    public tintOnDisable: boolean = false;
    public locked: boolean = false;
    public preservedState: boolean;

    private addPointerListeners(gameObject: GameObject, container: PIXI.Container): void {
        container.on('pointerdown', (e: any) => {
            gameObject.emit(GameObjectEvent.POINTER_DOWN);
            //e.stopPropagation();
            Interactable.pointerTargetGameObject = gameObject;
        });
        container.on('pointerup', () => {
            gameObject.emit(GameObjectEvent.POINTER_UP);
            if (gameObject === Interactable.pointerTargetGameObject) {
                gameObject.emit(GameObjectEvent.SELECTED, gameObject);
            }
            Interactable.pointerTargetGameObject = null;
        });
        container.on('pointerover', () => {
            gameObject.emit(GameObjectEvent.POINTER_OVER);
        });
        container.on('pointerout', () => {
            gameObject.emit(GameObjectEvent.POINTER_OUT);
        });
        container.on('pointerupoutside', () => {
            gameObject.emit(GameObjectEvent.POINTER_OUT);
            Interactable.pointerTargetGameObject = null;
        });
    }

    private removePointerListeners(gameObject: GameObject, container: PIXI.Container): void {
        container.off('pointerdown');
        container.off('pointerup');
        container.off('pointerover');
        container.off('pointerout');
        container.off('pointerupoutside');
    }

    public attach(gameObject: GameObject<PIXI.Container>, params: any): void {
        if (!params) params = {};

        if (params.enabled === undefined) {
            params.enabled = true;
        }

        super.attach(gameObject, params);
    }

    public onAttach(gameObject: GameObject, container: PIXI.Container): void {
        //this.addPointerListeners(gameObject, container);
        //this.enabled = this._enabled;
    }

    public onDetach(gameObject: GameObject, container: PIXI.Container): void {
        this.removePointerListeners(gameObject, container);
    }

    public toggle = (value?: boolean): void => {
        if (this.toggleable && this.preservedState !== undefined) {
            this.locked = value !== undefined;
            this.setEnabled(value === undefined ? this.preservedState : value);
            this.gameObject.emit(GameObjectEvent.TOGGLED, value);
        }
    };

    private setEnabled(value: boolean): void {
        if (value) {
            this.addPointerListeners(this.gameObject, this.container);
        } else {
            this.removePointerListeners(this.gameObject, this.container);
        }

        if (this.tintOnDisable) {
            if (this.gameObject.hasComponent(ColorFilter)) {
                this.gameObject.getComponent(ColorFilter).saturation = MathHelper.clamp(Number(value), 0.2, 1);
            } else {
                this.gameObject.addComponent(ColorFilter, {
                    saturation: MathHelper.clamp(Number(value), 0.2, 1),
                });
            }
            /* TODO: For smooth color transition. Crashes?
            StartAnimation(this.gameObject, 'Saturation', {
                startSaturation: MathHelper.clamp(Number(!value), 0.2, 1),
                endSaturation: MathHelper.clamp(Number(value), 0.2, 1),
                duration: 150
            });
            */
        }
        this.gameObject.emit('Enabled', value);
    }

    get enabled(): boolean {
        return this.container.interactive;
    }

    set enabled(value: boolean) {
        if (value !== this.container.interactive && !this.locked) {
            this.setEnabled(value);
        }

        this.container.interactive = value;
        this.preservedState = value;
    }

    get buttonMode(): boolean {
        return this.container.buttonMode;
    }

    set buttonMode(value: boolean) {
        this.container.buttonMode = value;
    }

    get toggleable(): boolean {
        return this._toggleable;
    }
    set toggleable(value: boolean) {
        this.setTaskListeners(value);
        this._toggleable = value;
    }
    get hitArea(): PIXI.HitArea {
        return this.container.hitArea;
    }
    set hitArea(value: PIXI.HitArea) {
        this.container.hitArea = value;
    }

    private toggleOff = () => {
        this.toggle(false);
    };

    private setTaskListeners(value: boolean) {
        if (value) {
            Game.scene.getActiveScene().on(TaskEvents.START, this.toggleOff);
            Game.scene.getActiveScene().on(TaskEvents.COMPLETE, this.toggle);
        } else {
            Game.scene.getActiveScene().off(TaskEvents.START, this.toggleOff);
            Game.scene.getActiveScene().off(TaskEvents.COMPLETE, this.toggle);
        }
    }
}
